<template>
  <section>
    <v-dialog
      v-model="showDialog"
      width="400px"
      @closed="handleClosed"
      @open="handleOpen">
      <div class="dialog-container">
        <div class="dialog-header">
          <p>Rate Details</p>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="changeDialog"></font-awesome-icon>
        </div>
        <div class="dialog-body">
          <el-form
            ref="formData"
            :model="formData"
            :rules="rules">
            <span class="name">Rate</span>
            <el-form-item prop="rate_pct">
              <v-input
                v-model="formData.rate_pct"
                money
                append="%"></v-input>
            </el-form-item>
            <span>
              <el-form-item
                prop="radioType"
                class="radio">
                <v-radio-group
                  v-model="formData.radioType"
                  :list="radioList"
                  @change="handleRadio"></v-radio-group>
              </el-form-item>
            </span>
            <el-form-item prop="cmnt_dt">
              <v-date-picker
                v-model="formData.cmnt_dt"
                :pickerOptions="pickerOptions"
                :disabled="formData.radioType == 0"></v-date-picker>
            </el-form-item>
          </el-form>
          <div class="btn-list">
            <v-button
              gray
              @click="changeDialog">Cancel</v-button>
            <v-button
              green
              @click="handleSave">Save</v-button>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
export default {
  name: 'InsurerRateDetail',
  props:{
    form:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    const checkDateRequired = (rule, value, cb) => {
      if(this.formData.radioType == 1 && !value){
        cb(new Error(this.$t('placeholder.select')))
      }
      cb()
    }
    return {
      showDialog: false,
      formData: {
        radioType: 0,
        cmnt_dt: '',
        rate_pct: ''
      },
      rules:{
        rate_pct:[
          {required: true, message: this.$t('placeholder.input'), trigger:['change', 'blur']}
        ],
        cmnt_dt: [
          {validator: checkDateRequired, trigger: ['change', 'blur']}
        ]
      },
      radioList:[
        {
          id: 0,
          name: 'Start Now'
        },
        {
          id: 1,
          name: 'Schedule'
        }
      ],
      pickerOptions: {
        disabledDate(time){
          return time.getTime() < Date.now()
        }
      },
    }
  },
  methods: {
    changeDialog(){
      this.showDialog = !this.showDialog
    },
    handleRadio(val){
      if(val == 0){
        this.formData.cmnt_dt = ''
        this.$refs['formData'].clearValidate(['cmnt_dt'])
      }
    },
    handleSave(){
      this.$refs['formData'].validate(valid => {
        if(valid){
          if(this.form && this.form.id){
            // edit
            let params = {
              id: this.form.id,
              cmnt_dt: this.formData.cmnt_dt,
              rate_pct: this.formData.rate_pct
            }
            this.$emit('edit', params)
          }else{
            // add
            const {cmnt_dt, rate_pct} = this.formData
            let params = {
              cmnt_dt,
              rate_pct
            }
            this.$emit('save', params)
          }
        }
      })
    },
    handleOpen(){
      this.$nextTick(() => {
        let val = this.form
        this.$refs['formData'].clearValidate()
        if(val && val.id){
          this.formData.radioType = 1
          let cmnt_dt = val.cmnt_date
          let arr = cmnt_dt.split('-')
          let date = arr[2]+'-'+arr[1]+'-'+arr[0]
          this.formData.cmnt_dt = date
          this.formData.rate_pct = val.pct_rate
        }
      })
    },
    handleClosed(){
      this.formData.radioType = 0
      this.formData.cmnt_dt = ''
      this.formData.rate_pct = ''
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 15px 15px 15px;
    .name{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
      margin-bottom: 8px;
      display: block;
    }
    .el-form-item{
      margin-bottom: 20px !important;
    }
    .radio{
      margin-bottom: 0 !important;
    }
    /deep/.el-radio-group{
      display: flex;
      flex-direction: column;
      .el-radio{
        margin-bottom: 6px;
      }
    }
    .btn-list{
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
